<template>
  <div>
    <div v-if="!Boolean(image)">
      <label
        for="file-input"
        class="file-label"
        :class="isDragging ? 'border-info' : 'border-primary'"
        @dragover="handleDragOver"
        @dragleave="handleDragLeave"
        @drop="handleDrop"
      >
        <b-icon
          class="upload-file"
          :variant="isDragging ? 'info' : 'primary'"
          :icon="isDragging ? 'archive' : 'cloud-arrow-up'"
        />
        <p>Clique aqui ou arraste uma imagem/video para fazer o upload</p>
      </label>
      <input
        id="file-input"
        type="file"
        accept=".jpg, .jpeg, .png, .mp4, .mov"
        class="file-input"
        @change="handleFileUpload"
      />
    </div>
    <div v-if="isImage" class="image-preview">
      <img :src="preview" alt="image preview" />
      <b-icon class="remove-img" icon="x-circle" @click="clearImage" />
    </div>

    <div v-if="isVideo" class="image-preview">
      <video alt="video preview" controls>
        <source :src="preview" type="video/quicktime" />
        <source :src="preview" type="video/mp4" />
        Seu navegador não suporta esse arquivo!
      </video>
      <b-icon class="remove-img" icon="x-circle" @click="clearImage" />
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { mapGetters } from "vuex/dist/vuex.common.js";

export default {
  props: {
    select: { type: Function, require: true },
    size: { type: Boolean, require: true },
  },
  data() {
    return {
      image: null,
      preview: ref(""),
      isDragging: ref(false),
      isVideo: false,
      isImage: false,
    };
  },
  methods: {
    handleFileUpload(event) {
      let file = event.target.files[0];
      this.image = file;

      this.select(file);

      this.preview = URL.createObjectURL(file);

      if (file.type.startsWith("video/")) {
        this.isImage = false;
        this.isVideo = true;
      } else {
        this.isImage = true;
        this.isVideo = false;
      }
    },
    handleDragOver(event) {
      event.preventDefault();
      const text = document.querySelector(".file-label p");

      text.innerHTML = "Solte o arquivo!";
      event.target.classList.add("drag-over");
      this.isDragging = true;
    },
    handleDragLeave(event) {
      const text = document.querySelector(".file-label p");

      text.innerHTML =
        "Clique aqui ou arraste uma imagem/video para fazer o upload";
      event.target.classList.remove("drag-over");
      this.isDragging = false;
    },
    handleDrop(event) {
      event.preventDefault();
      event.target.classList.remove("drag-over");
      const text = document.querySelector(".file-label p");
      text.innerHTML =
        "Clique aqui ou arraste uma imagem/video para fazer o upload";

      const file = event.dataTransfer.files[0];
      this.image = file;

      this.select(file);

      this.preview = URL.createObjectURL(file);

      this.isDragging = false;

      if (file.type.startsWith("video/")) {
        this.isImage = false;
        this.isVideo = true;
      } else {
        this.isImage = true;
        this.isVideo = false;
      }
    },

    clearImage() {
      this.image = null;
      this.preview = "";
      this.isImage = false;
      this.isVideo = false;
    },
  },
};
</script>

<style>
.file-label {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 350px;
  height: 250px;
  padding: 10px;
  border-radius: 8px;
  border: 2px dashed;
  text-align: center;
  cursor: pointer;
}

.file-label .upload-file {
  font-size: 3rem;
}

.file-input {
  display: none;
}

.image-preview {
  margin-top: 8px;
  width: 100%;
  max-width: 320px;
  height: 100%;
  max-height: 240px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-preview img,
.image-preview video {
  width: auto;
  max-width: 320px;
  height: auto;
  max-height: 240px;
  border-radius: 8px;
}

.image-preview .remove-img {
  position: absolute;
  top: 4px;
  right: 4px;
  color: red;
}

.image-preview .remove-img:hover {
  cursor: pointer;
}
</style>
